/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "پرون",
        "0": "نن",
        "1": "سبا",
        "future": {
          "one": "په {0} ورځ کې",
          "other": "په {0} ورځو کې"
        },
        "past": {
          "one": "{0} ورځ مخکې",
          "other": "{0} ورځې مخکې"
        }
      },
      "day-narrow": {
        "-1": "پرون",
        "0": "نن",
        "1": "سبا",
        "future": {
          "one": "په {0} ورځ کې",
          "other": "په {0} ورځو کې"
        },
        "past": {
          "one": "{0} ورځ مخکې",
          "other": "{0} ورځې مخکې"
        }
      },
      "day-short": {
        "-1": "پرون",
        "0": "نن",
        "1": "سبا",
        "future": {
          "one": "په {0} ورځ کې",
          "other": "په {0} ورځو کې"
        },
        "past": {
          "one": "{0} ورځ مخکې",
          "other": "{0} ورځې مخکې"
        }
      },
      "hour": {
        "0": "دا ساعت",
        "future": {
          "one": "په {0} ساعت کې",
          "other": "په {0} ساعتو کې"
        },
        "past": {
          "one": "{0} ساعت مخکې",
          "other": "{0} ساعتونه مخکې"
        }
      },
      "hour-narrow": {
        "0": "دا ساعت",
        "future": {
          "one": "په {0} ساعت کې",
          "other": "په {0} ساعت کې"
        },
        "past": {
          "one": "{0} ساعت مخکې",
          "other": "{0} ساعت مخکې"
        }
      },
      "hour-short": {
        "0": "دا ساعت",
        "future": {
          "one": "په {0} ساعت کې",
          "other": "په {0} ساعت کې"
        },
        "past": {
          "one": "{0} ساعت مخکې",
          "other": "{0} ساعت مخکې"
        }
      },
      "minute": {
        "0": "دا دقيقه",
        "future": {
          "one": "په {0} دقيقه کې",
          "other": "په {0} دقيقو کې"
        },
        "past": {
          "one": "{0} دقيقه مخکې",
          "other": "{0} دقيقې مخکې"
        }
      },
      "minute-narrow": {
        "0": "دا دقيقه",
        "future": {
          "one": "په {0} دقيقه کې",
          "other": "په {0} دقيقه کې"
        },
        "past": {
          "one": "{0} دقيقه مخکې",
          "other": "{0} دقيقه مخکې"
        }
      },
      "minute-short": {
        "0": "دا دقيقه",
        "future": {
          "one": "په {0} دقيقه کې",
          "other": "په {0} دقيقه کې"
        },
        "past": {
          "one": "{0} دقيقه مخکې",
          "other": "{0} دقيقه مخکې"
        }
      },
      "month": {
        "-1": "تېره مياشت",
        "0": "دا مياشت",
        "1": "راتلونکې مياشت",
        "future": {
          "one": "په {0} مياشت کې",
          "other": "په {0} مياشتو کې"
        },
        "past": {
          "one": "{0} مياشت مخکې",
          "other": "{0} مياشتې مخکې"
        }
      },
      "month-narrow": {
        "-1": "تېره مياشت",
        "0": "دا مياشت",
        "1": "راتلونکې مياشت",
        "future": {
          "one": "په {0} مياشت کې",
          "other": "په {0} مياشت کې"
        },
        "past": {
          "one": "{0} مياشت مخکې",
          "other": "{0} مياشت مخکې"
        }
      },
      "month-short": {
        "-1": "تېره مياشت",
        "0": "دا مياشت",
        "1": "راتلونکې مياشت",
        "future": {
          "one": "په {0} مياشت کې",
          "other": "په {0} مياشت کې"
        },
        "past": {
          "one": "{0} مياشت مخکې",
          "other": "{0} مياشت مخکې"
        }
      },
      "nu": ["arabext"],
      "quarter": {
        "-1": "ورستۍ ربع",
        "0": "دا ربع",
        "1": "راتلونکې ربع",
        "future": {
          "one": "په {0} ربع کې",
          "other": "په {0} ربعو کې"
        },
        "past": {
          "one": "{0} ربع مخکې",
          "other": "{0} ربعې مخکې"
        }
      },
      "quarter-narrow": {
        "-1": "ورستۍ ربع",
        "0": "دا ربع",
        "1": "راتلونکې ربع",
        "future": {
          "one": "په {0} ربع کې",
          "other": "په {0} ربعو کې"
        },
        "past": {
          "one": "{0} ربع مخکې",
          "other": "{0} ربعې مخکې"
        }
      },
      "quarter-short": {
        "-1": "ورستۍ ربع",
        "0": "دا ربع",
        "1": "راتلونکې ربع",
        "future": {
          "one": "په {0} ربع کې",
          "other": "په {0} ربعو کې"
        },
        "past": {
          "one": "{0} ربع مخکې",
          "other": "{0} ربعې مخکې"
        }
      },
      "second": {
        "0": "اوس",
        "future": {
          "one": "په {0} ثانيه کې",
          "other": "په {0} ثانيو کې"
        },
        "past": {
          "one": "{0} ثانيه مخکې",
          "other": "{0} ثانيې مخکې"
        }
      },
      "second-narrow": {
        "0": "اوس",
        "future": {
          "one": "په {0} ثانيه کې",
          "other": "په {0} ثانيه کې"
        },
        "past": {
          "one": "{0} ثانيه کې",
          "other": "{0} ثانيه کې"
        }
      },
      "second-short": {
        "0": "اوس",
        "future": {
          "one": "په {0} ثانيه کې",
          "other": "په {0} ثانيه کې"
        },
        "past": {
          "one": "{0} ثانيه مخکې",
          "other": "{0} ثانيه مخکې"
        }
      },
      "week": {
        "-1": "تيره اونۍ",
        "0": "دا اونۍ",
        "1": "راتلونکې اونۍ",
        "future": {
          "one": "په {0} اونۍ کې",
          "other": "په {0} اونيو کې"
        },
        "past": {
          "one": "{0} اونۍ مخکې",
          "other": "{0} اونۍ مخکې"
        }
      },
      "week-narrow": {
        "-1": "تېره اونۍ",
        "0": "دا اونۍ",
        "1": "راتلونکې اونۍ",
        "future": {
          "one": "په {0} اونۍ کې",
          "other": "په {0} اونۍ کې"
        },
        "past": {
          "one": "{0} اونۍ مخکې",
          "other": "{0} اونۍ مخکې"
        }
      },
      "week-short": {
        "-1": "تېره اونۍ",
        "0": "دا اونۍ",
        "1": "راتلونکې اونۍ",
        "future": {
          "one": "په {0} اونۍ کې",
          "other": "په {0} اونۍ کې"
        },
        "past": {
          "one": "{0} اونۍ مخکې",
          "other": "{0} اونۍ مخکې"
        }
      },
      "year": {
        "-1": "پروسږکال",
        "0": "سږکال",
        "1": "راتلونکی کال",
        "future": {
          "one": "په {0} کال کے",
          "other": "په {0} کالونو کے"
        },
        "past": {
          "one": "{0} کال مخکے",
          "other": "{0} کاله مخکے"
        }
      },
      "year-narrow": {
        "-1": "تير کال",
        "0": "سږ کال",
        "1": "راتلونکی کال",
        "future": {
          "one": "په {0} کال کے",
          "other": "په {0} کالونو کے"
        },
        "past": {
          "one": "{0} کال مخکے",
          "other": "{0} کاله مخکے"
        }
      },
      "year-short": {
        "-1": "تېر کال",
        "0": "سږ کال",
        "1": "روتلونکی کال",
        "future": {
          "one": "په {0} کال کے",
          "other": "په {0} کالونو کے"
        },
        "past": {
          "one": "{0} کال مخکے",
          "other": "{0} کاله مخکے"
        }
      }
    },
    "locale": "ps-PK"
  });
}